import { render, staticRenderFns } from "./FeatureTypeStructureSource.vue?vue&type=template&id=2ae0c4e2&scoped=true"
import script from "./FeatureTypeStructureSource.vue?vue&type=script&lang=js"
export * from "./FeatureTypeStructureSource.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeStructureSource.vue?vue&type=style&index=0&id=2ae0c4e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0c4e2",
  null
  
)

export default component.exports